@if (impersonatedClient) {
  <div class="client-info-bar">
    <div class="client-info">
      <mat-icon>person</mat-icon>
      <strong>{{ impersonatedClient.company }}</strong>
      @if (impersonatedClient.apikey) {
        <span class="client-id">#{{ impersonatedClient.apikey.client_id }}</span>
      }
      <span class="client-username">{{ impersonatedClient.username }}</span>
    </div>
    <div class="client-actions">
      <button mat-stroked-button color="primary" (click)="exitImpersonation()">
        <mat-icon>logout</mat-icon>
        {{ 'sidebar.return_admin' | translate }}
      </button>
    </div>
  </div>
}